<template>
    <svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M37.3636 7H4.63636C2.62806 7 1 8.62297 1 10.625V32.375C1 34.377 2.62806 36 4.63636 36H37.3636C39.3719 36 41 34.377 41 32.375V10.625C41 8.62297 39.3719 7 37.3636 7Z" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1 18L41 18" stroke="#202830" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCreditCard',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
